"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyPairFrom = exports.ec = void 0;
const elliptic_1 = __importDefault(require("elliptic"));
const crypto_error_1 = require("./crypto-error");
exports.ec = new elliptic_1.default.ec('secp256k1');
const keyPairFrom = (key, kind) => {
    let errorCause;
    try {
        const pair = kind === 'private' ? exports.ec.keyFromPrivate(key) : exports.ec.keyFromPublic(key);
        if (pair && pair.validate().result) {
            return pair;
        }
    }
    catch (e) {
        errorCause = e;
    }
    throw new crypto_error_1.CryptoError('Invalid key format', errorCause);
};
exports.keyPairFrom = keyPairFrom;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZWMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsd0RBQXlCO0FBRXpCLGlEQUE0QztBQUUvQixRQUFBLEVBQUUsR0FBRyxJQUFJLGtCQUFFLENBQUMsRUFBRSxDQUFDLFdBQVcsQ0FBQyxDQUFBO0FBRWpDLE1BQU0sV0FBVyxHQUFHLENBQUMsR0FBVyxFQUFFLElBQTBCLEVBQUUsRUFBRTtJQUNyRSxJQUFJLFVBQW1CLENBQUE7SUFFdkIsSUFBSSxDQUFDO1FBQ0gsTUFBTSxJQUFJLEdBQUcsSUFBSSxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUMsVUFBRSxDQUFDLGNBQWMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBRSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsQ0FBQTtRQUNoRixJQUFJLElBQUksSUFBSSxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUMsTUFBTSxFQUFFLENBQUM7WUFDbkMsT0FBTyxJQUFJLENBQUE7UUFDYixDQUFDO0lBQ0gsQ0FBQztJQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7UUFDWCxVQUFVLEdBQUcsQ0FBQyxDQUFBO0lBQ2hCLENBQUM7SUFFRCxNQUFNLElBQUksMEJBQVcsQ0FBQyxvQkFBb0IsRUFBRSxVQUFVLENBQUMsQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFiWSxRQUFBLFdBQVcsZUFhdkIifQ==